import { mount } from 'svelte'
import App from './App.svelte'
import "../static/style.css"
import "../static/post.css"
import "./calendar.css"

const app = mount(App, {
  target: document.getElementById('app'),
})

export default app

